import { makeAutoObservable } from 'mobx';

// UI 상태 (제품 커버플로우 인덱스, 모바일 메뉴, 스크롤 등)
export class UiStore {
  activeProduct = 0;      // 제품 소개 커버플로우 활성 인덱스
  dir = 1;                // 전환 방향 (1=다음, -1=이전)
  productCount = 0;       // ContentStore에서 주입
  activeService = 0;      // 고객지원 아코디언 활성 항목(목업: 좌 리스트 클릭 → 우 패널 전환)
  mobileMenuOpen = false;
  scrolled = false;       // 최상단 벗어남(프로스트 배경 on/off)
  headerHidden = false;   // auto-hide: 아래로 스크롤 시 헤더를 위로 숨김(목업 동일)

  constructor() {
    makeAutoObservable(this);
  }

  setProductCount(n: number) { this.productCount = n; }

  nextProduct() {
    if (this.productCount === 0) return;
    this.dir = 1;
    this.activeProduct = (this.activeProduct + 1) % this.productCount;
  }
  prevProduct() {
    if (this.productCount === 0) return;
    this.dir = -1;
    this.activeProduct = (this.activeProduct - 1 + this.productCount) % this.productCount;
  }
  setActiveProduct(i: number) { this.dir = i > this.activeProduct ? 1 : -1; this.activeProduct = i; }

  toggleMobileMenu() { this.mobileMenuOpen = !this.mobileMenuOpen; }
  setScrolled(v: boolean) { this.scrolled = v; }
  setHeaderHidden(v: boolean) { this.headerHidden = v; }
  setActiveService(i: number) { this.activeService = i; }
}
